import {useState,useEffect,useRef} from 'react';
import axios from 'axios';
import { useSelector,useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ajoutsuccess,showmodal,showetat,modifsuccess,listclient,getList,idfacture,showapercu } from "./FactureSlice";
import Impressiongroupe from './Impressiongroupe';
// import ModalApercu from './ModalApercu';
import Etatfacture from './Etatfacture';

export default function Factures() {
    const Facturedata = useSelector(state => state.facturesData);
    const ajoutSuccess = Facturedata.ajoutsuccess;
    const modifSuccess = Facturedata.modifsuccess;
    const listFactures = Facturedata.list;
    const id = useSelector(state => state.userData.id);

    const [Chargement, setChargement] = useState(false);
    const [removeSuccess, setRemoveSuccess] = useState(false);
    const [rechercheInput,setRchercheInput] = useState('');
    const [rechercheFactureInput,setrechercheFactureInput] = useState('');
    const [rechercheReglementInput,setrechercheReglementInput] = useState('tout');
    const [rechercheLivraisonInput,setrechercheLivraisonInput] = useState('tout');
    const [dateDebutInput,setDateDebutInput] = useState('');
    const [dateFinInput,setDateFinInput] = useState('');

    const dispatch= useDispatch();
    const navigate = useNavigate();

    const rechercheField=useRef('');
    const rechercheFactureField=useRef('');
    const rechercheReglementField=useRef('');
    const rechercheLivraisonField=useRef('');
    const dateDebutField=useRef('');
    const dateFinField=useRef('');

    const currentAvoir=useRef('');
    const currentTotal=useRef('');
    let listAchats=useRef([]);


    const formatDateToFrench = (dateString) => {
        const [date] = dateString.split('T');
        const [year, month, day] = date.split('-');
        return `${day}/${month}/${year}`;
      };

    const apiUrl = process.env.REACT_APP_API_URL;
    const Ajouter=() => {
        navigate('/home/nouvellefacture');
        }

        const HideSuccessMsg = () => {
            setTimeout(() => {
                dispatch(ajoutsuccess(false));
                dispatch(modifsuccess(false));
                setRemoveSuccess(false);
        
            }, 5000);
        }   

        const GetClients=async () => {
            try {
            const response = await axios.post(`${apiUrl}clients/${id}`);
              dispatch(listclient(response.data));
            }
         catch (error) {
            console.error('Error:', error);
        }
        }

        const getFactures=async () => {
            setChargement(true);
            try {
            const apiUrl = process.env.REACT_APP_API_URL;
            const response = await axios.post(`${apiUrl}factures/${id}`);
            dispatch(getList(response.data));
            }
         catch (error) {
            console.error('Error:', error);    
        }
        setChargement(false);
        }
        const GetFacture = async (idfacture,facture,date) =>{
            setChargement(true);
            try {
                const dateFr=formatDateToFrench(date)
                const response = await axios.get(`${apiUrl}generer/facture/${id}/${idfacture}`,{
                  responseType: 'blob',
                });
            
                // Créez un lien pour télécharger le PDF
                const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download',`Facture N${facture} ${dateFr}.pdf`);
                document.body.appendChild(link);
                link.click();
            }
                catch (error) {
                    console.error('Error generating invoice:', error);
                  }
                  setChargement(false);
        }
    
        const suppression = async (idfacture)=> {

            try {
                const apiUrl = process.env.REACT_APP_API_URL;
                const response = await axios.post(`${apiUrl}delete/facture/${id}/${idfacture}`);
                if(response.data.status==="ok")
                    {
                        const newlist=listFactures.filter(facture => facture._id !== idfacture);
                        dispatch(getList(newlist));
                        setRemoveSuccess(true);
                        HideSuccessMsg();
                    }
            } catch (error) {
                console.log(error)
            }
        }

        const supprimer = (id,numero) => {
            let result = window.confirm(`Supprimer la facture N° ${numero} ?`);
            if (result === true) {
                suppression(id);
            }
        }

        const formatDateToEnglish = (dateString) => {
            const [date] = dateString.split('T');
            return `${date}`;
          };
    
        function ShowList() {
            HideSuccessMsg();
            let StyleColor = "#99FBA9";
            let StyleColor2 = "#99FBA9";
            let listFiltre=listFactures;
            const debut = dateDebutField.current.value
            const fin = dateFinField.current.value
            if(rechercheInput.length > 0) {
                listFiltre = listFiltre.filter(facture => facture.client.some(client => client.designation.toLowerCase().includes(rechercheInput)))
            }
            if(rechercheFactureInput > 0)
                {
                    listFiltre = listFiltre.filter(facture => facture.facture===rechercheFactureInput)                   
                }
            if(rechercheReglementInput !=="tout")
                {
                    listFiltre = listFiltre.filter(facture => facture.etat===rechercheReglementInput)                   
                }
            if(rechercheLivraisonInput !=="tout")
                {
                    listFiltre = listFiltre.filter(facture => facture.livraison===rechercheLivraisonInput)                   
                }
            
                if(debut !=="")
                {
                    listFiltre = listFiltre.filter(facture => formatDateToEnglish(facture.date)>=debut)      
                }

                if(fin !=="")
                    {
                        listFiltre = listFiltre.filter(facture => formatDateToEnglish(facture.date)<=fin)      
                    }
            return listFiltre.map(facture => {
                if(facture.etat!=="Réglée"){
                    StyleColor = "#FBD399"
                  }
                  if(facture.livraison!=="Livrée"){
                    StyleColor2 = "#FBD399"
                  }
            return(
                <tr key={facture._id}>
                {facture.client.map(leclient => (
                <td style={{ maxWidth: "270px" }}>{leclient.designation}</td>
                ))}
                <td>{facture.facture?.toString().padStart(5, '0')}</td>
                <td>{facture.total} Dhs</td>
                <td>{facture.reglement}</td>
                <td style={{color:StyleColor}}>{facture.etat}</td>
                <td style={{color:StyleColor2}}>{facture.livraison}</td>
                <td>{facture.date!=="" ? formatDateToFrench(facture.date) : ''}</td>
                <td>
                    <div>
                <button type="button" style={{ width: '90px' }} class="btn btn-success me-4" onClick={() => ShowFacture(facture._id,facture.total_brute,facture.avoir)}>Aperçu</button>
                <button type="button" style={{ width: '100px' }} class="btn btn-primary me-4" onClick={() => modifier(facture._id)}>Modifier</button>
                <button type="button" class="btn btn-warning me-4" onClick={() => modifierPrix(facture._id)}>Modifier prix</button>
                </div>
                <div class="mt-2">
                <button type="button" class="btn btn-info me-4" onClick={() => GetFacture(facture._id,facture.facture,facture.date)}>Imprimer</button>
                <button type="button" class="btn btn-danger" onClick={() => supprimer(facture._id,facture.facture)}>Supprimer</button>
                </div>
                </td>

                </tr>
            )
            }
            )
        }

        const Recherche=(event) =>{
            const recherche=rechercheField.current.value
            const rechercheFacture=rechercheFactureField.current.value
            const rechercheReglement = rechercheReglementField.current.value
            const rechercheLivraison = rechercheLivraisonField.current.value
            const debut= dateDebutField.current.value
            const fin=dateFinField.current.value

            if(recherche!==rechercheInput){
            setRchercheInput(recherche)
             }
            if(rechercheFacture!==rechercheFactureInput){
                setrechercheFactureInput(rechercheFacture)
                 }
            if(rechercheReglement!==rechercheReglementInput){
                setrechercheReglementInput(rechercheReglement)
                }
            if(rechercheLivraison!==rechercheLivraisonInput){
                setrechercheLivraisonInput(rechercheLivraison)
                }
            
                if(debut!==dateDebutInput){
                    setDateDebutInput(debut)
                    }
            
                    if(fin!==dateFinInput){
                        setDateFinInput(fin)
                        }
            

        }


        function generateTableRows() {
            let remiseAvoir = currentAvoir.montant ? parseFloat(currentAvoir.montant) : 0;
            const listFiltre = listAchats.current.filter(achat => achat.stock > 0);
            
            // Convertir le JSX en HTML string
            return listFiltre.map(achat => `
              <tr key="${achat._id}">
                <td style="padding: 12px 15px;text-align: left;border-bottom: 1px solid #e0e0e0;transition: background-color 0.2s;">${achat.designation}</td>
                <td style="padding: 12px 15px;text-align: left;border-bottom: 1px solid #e0e0e0;transition: background-color 0.2s;">${achat.stock}</td>
                <td style="padding: 12px 15px;text-align: left;border-bottom: 1px solid #e0e0e0;transition: background-color 0.2s;">${achat.prix_vente}</td>
              </tr>
            `).join(''); // .join('') pour concaténer toutes les lignes
          }

        const ShowFacture = async (idfacture,total,avoir) => {
            try {
            currentAvoir.current = {
                "id" : avoir["0"].id,
                "numero" : avoir["0"].numero,
                "montant" : avoir["0"].montant,

            }   
        } 
        catch (error) {
            currentAvoir.current=''
        }     
            currentTotal.current = total
            // setChargement(true);
            try {
                
                listAchats.current=[]
                const apiUrl = process.env.REACT_APP_API_URL;
                const response = await axios.post(`${apiUrl}list/facture/${id}/${idfacture}`);
                   response.data.produits.map(product => {
                    const _id=product._id
                    const designation=product.designation
                    const stock=product.stock
                    const prix_vente=product.prix_vente;
                    const prix_achat=product.prix_achat;
                    const tva=product.tva;
                    
                    const existingProductIndex = listAchats.current.findIndex(item => item._id === _id);
                    if (existingProductIndex === -1) {
                        const valeurs={_id,designation,stock,prix_vente,prix_achat,tva};
                    listAchats.current.push({...valeurs});
                    }
                });   
                // dispatch(showapercu(true)) 
                const popup = window.open('', 'Aperçu', 'width=600,height=400,top=100,left=100')
                popup.document.body.innerHTML = ''
            
                popup.document.write(`
                    <html>
                      <head><title>Mon Tableau</title></head>
                      <body style="font-family: Arial, sans-serif; background-color: #f4f4f4; padding: 20px;">
                        <h2>Aperçu Facture</h2>
                        <table style="width: 100%; border-collapse: separate; border-spacing: 0 10px;background-color: #fff;box-shadow: 0 2px 4px rgba(0,0,0,0.1);">
                          <tr>
                        <th style="padding: 12px 15px;text-align: left;border-bottom: 1px solid #e0e0e0;background-color: #f1f3f5;font-weight: 600;color: #333;">Produit</th>
                        <th style="padding: 12px 15px;text-align: left;border-bottom: 1px solid #e0e0e0;background-color: #f1f3f5;font-weight: 600;color: #333;">Quantité</th>
                        <th style="padding: 12px 15px;text-align: left;border-bottom: 1px solid #e0e0e0;background-color: #f1f3f5;font-weight: 600;color: #333;">Prix HT</th> 
                          </tr>
                          <tr>
                          ${generateTableRows()}
                          </tr>
                        </table>
                      </body>
                    </html>
                  `);

            }
             catch (error) {
                console.error('Error:', error);    
            }
            // setChargement(false);
        
        }

        const modifier = (id) => {
            const filtreachat = listFactures.filter(list => list._id === id);
            dispatch(idfacture(filtreachat));
            navigate('/home/editfacture');
          }

          const modifierPrix = (id) => {
            const filtreachat = listFactures.filter(list => list._id === id);
            dispatch(idfacture(filtreachat));
            navigate('/home/editprixfacture');
          }

          const ImpressionGroupe = () => dispatch(showmodal(true));

          const EtatVente = () => dispatch(showetat(true));
        useEffect(() =>{
            getFactures();
            GetClients();
            HideSuccessMsg();
          },[])

          
    return (
        <>
        <div className="container-lg align-items-center">
    <section className="mt-4">
        <p className="h2 text-center">Factures</p>
    
        {Chargement? 
                    <div d-flex className="d-flex justify-content-center">
                    <div className="spinner-grow" style={{width: '3rem', height: '3rem'}} role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  </div>
                :
                <div style={{ height: '3rem' }}></div>
                }
    
        <div className="d-flex justify-content-end mb-3">
            
        <button className="btn btn-primary mr-2" onClick={Ajouter}>
          <i className="fas fa-user-plus"></i> Nouvelle facture
        </button>

        <button className="btn btn-secondary ms-2" onClick={ImpressionGroupe}>
          <i className="fas fa-user-plus"></i> Impression groupée
        </button>

        <button className="btn btn-success ms-2" onClick={EtatVente}>
          <i className="fas fa-user-plus"></i> Etat des ventes
        </button>
      </div>

      <div className="d-flex justify-content-start align-items-center mb-3 " >
      <input autoComplete="off" type="text" className="form-control " id="client"  placeholder="Recherche client" ref={rechercheField} onKeyUp={Recherche} ></input>
      <input autoComplete="off" type="text" className="form-control ms-2" id="facture"  placeholder="Recherche facture" ref={rechercheFactureField} onKeyUp={Recherche} ></input>
      <select className='form-select form-select-sm ms-2' id="Réglement" ref={rechercheReglementField} onChange={Recherche}>
        <option value="tout">Etat réglement</option>
        <option value="Réglée">Réglée</option>
        <option value="Non Réglée">Non Réglée</option>
      </select>
      <select className='form-select form-select-sm ms-2' id="livraison" ref={rechercheLivraisonField} onChange={Recherche}>
        <option value="tout">Etat livraison</option>
        <option value="Livrée">Livrée</option>
        <option value="Non Livrée">Non Livrée</option>
      </select>
      <label className="form-label ms-2" for="debut">Debut</label>
      <input autoComplete="off" type="date" className="form-control ms-2" id="debut" ref={dateDebutField} onChange={Recherche}></input>

      <label className="form-label ms-2" for="debut">Fin</label>
      <input autoComplete="off" type="date" className="form-control ms-2" id="fin" ref={dateFinField} onChange={Recherche}></input>
      </div>
    
      {ajoutSuccess ?
            <div class="alert alert-success  mb-4 text-center" role="alert">
            <strong>Facture ajoutée avec succès</strong>
            </div>                 
                :
                ''                    
            }
    
    {modifSuccess ?
            <div class="alert alert-success  mb-4 text-center" role="alert">
            <strong>Facture modifiée avec succès</strong>
            </div>                 
                :
                ''                    
            }
    
    {removeSuccess ?
            <div class="alert alert-success  mb-4 text-center" role="alert">
            <strong>Facture supprimée avec succès</strong>
            </div>                 
                :
                ''                    
            }
    
    {/* <div className="d-flex justify-content-start mb-3 w-25" >
      
      <select className="form-select" id="fournisseur" value={rechercheFournisseur} ref={fournisseurField} onChange={Recherche}>
            <option value="tout">Fournisseur</option>
                <Listfournisseurs/>
                </select>    
    
        </div> */}
        <div class="table-responsive">
      <table className="table  align-middle table-dark table-striped mb-3">
            <thead>
                <tr>
                    <th scope="col">Client</th>
                    <th scope="col">N° facture</th>
                    <th scope="col">Total TTC</th> 
                    <th scope="col">Méthode</th>
                    <th scope="col">Régelement</th>
                    <th scope="col">Livraison</th>
                    <th scope="col">Date</th>
                    <th scope="col">Action</th>
                </tr>
            </thead>
            <tbody>
                <ShowList/>
            </tbody>
        </table>
        </div>
    </section>
        </div>
        <Impressiongroupe/>
        <Etatfacture/>
        {/* <ModalApercu Achats ={listAchats} Total={currentTotal.current} Avoir={currentAvoir}/> */}

    </>
        
      )
    
}
